<template>
  <v-sheet
    light
    color="grey lighten-4"
    class="py-2 text-h5 text-center"
  >
    <v-btn
      id="h-pay-all"
      icon
      small
      color="primary"
      @click="payAll()"
    >
      <v-icon v-text="icons.action" />
    </v-btn>
    {{ floatValue | currency }}
  </v-sheet>
</template>

<script>
  import { mapState } from 'vuex'
  import Currenciable from '@/Mixins/Currenciable'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      Currenciable,
      UsesIcons,
    ],

    props: {
      value: {
        required: true,
        type: String,
      },
    },

    computed: {
      ...mapState('orders/payment', [
        'amountToPay',
        'tipAmount',
      ]),
      floatValue () {
        return parseInt(this.value) / 100
      },
    },

    methods: {
      payAll () {
        const amountToPay = this.amountToPay + this.tipAmount
        this.$emit('input', String(Math.round(amountToPay * 100)))
      },
    },
  }
</script>

<style lang="scss" scoped>
  #h-pay-all {
    position: absolute;
    left: 10px;
    margin-top: 2px;
  }
</style>
